import React from 'react';
import { styled } from 'styled-components';
import { baseStyle } from '../../../components/ClickableComponents/styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const channelWidth = 70;
export const channelHeight = 24;
export const ChannelIcon = ({
  channel,
  isActive,
  onClick
}) => /*#__PURE__*/_jsx(StyledChannelIcon, {
  onClick: onClick,
  isActive: isActive,
  fontType: "Medium",
  fontSize: {
    mediaQuery: [],
    default: 12
  },
  size: "default",
  isDisabled: false,
  expand: false,
  leftAligned: false,
  colorSet: {
    color: 'inherit'
  },
  multilineText: false,
  children: /*#__PURE__*/_jsx(LogoContainer, {
    children: /*#__PURE__*/_jsx(Logo, {
      alt: channel.title,
      src: channel.imageUrlRaw ?? channel.imageUrl
    })
  })
});
const StyledChannelIcon = styled(({
  children,
  className,
  onClick
}) => /*#__PURE__*/_jsx("button", {
  className: className,
  onClick: onClick,
  children: children
})).withConfig({
  displayName: "ChannelIcon__StyledChannelIcon",
  componentId: "sc-x14y1d-0"
})(["", ";"], baseStyle);
const LogoContainer = styled.div.withConfig({
  displayName: "ChannelIcon__LogoContainer",
  componentId: "sc-x14y1d-1"
})(["height:", "px;min-height:", "px;width:", "px;min-width:", "px;left:0;"], channelHeight, channelHeight, channelWidth, channelWidth);
const Logo = styled.img.withConfig({
  displayName: "ChannelIcon__Logo",
  componentId: "sc-x14y1d-2"
})(["height:100%;width:100%;object-fit:contain;"]);